module.exports = __webpack_public_path__ + "static/media/carousel-5.a626e1eb.png";